import { isPortal } from './helpers.js'

export default [
  {
    name: 'Booking',
    path: isPortal() ? '/book/:id' : '/portal/:account/book/:id',
    component: () => import(/* webpackChunkName: "book" */ '@/layouts/Book.vue'),
    children: [
      {
        name: 'BookOrigin',
        path: 'origin',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookOrigin.vue')
      },
      {
        name: 'BookDestination',
        path: 'destination',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookDestination.vue')
      },
      {
        name: 'BookDate',
        path: 'date',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookDate.vue')
      },
      {
        name: 'BookTime',
        path: 'time',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookTime.vue')
      },
      {
        name: 'BookDetails',
        path: 'details',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookDetails.vue')
      },
      {
        name: 'BookPayment',
        path: 'payment',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookPayment.vue')
      },
      {
        name: 'BookConfirm',
        path: 'confirm',
        component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookConfirm.vue')
      }
    ]
  },
  {
    name: 'BookSuccess',
    path: isPortal() ? '/book/:id/success' : '/portal/:account/book/:id/success',
    component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookSuccess.vue'),
  },
  {
    name: 'BookWaybills',
    path: isPortal() ? '/book/:id/waybills' : '/portal/:account/book/:id/waybills',
    component: () => import(/* webpackChunkName: "book" */ '@/views/book/BookWaybills.vue'),
  }
]